import React, { useEffect } from 'react'
import { Widget, useUpdate, useValidation } from './base/widget'
import { AlignLeftOutlined } from '@ant-design/icons'
import { FormItem, styleIconValidation } from './base/styles'
import { CommonFields } from './base/widgetCommonFields'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import {
	ckeditorCss,
	resizableCkeditorStylesForDocumentDetail,
} from 'utils/ckeditorStylingDeffaults'
import { object } from 'prop-types'
import { Input } from 'antd'
import { useSelector } from 'react-redux'

export const ParagraphCkeditorWidget = React.memo((props) => {
	const { data } = props

	const update = useUpdate(props)
	const [valid, setValid] = useValidation(props)
	const hasContextAi = useSelector(
		({ editTemplate }) => editTemplate.data.config.contextAi
	)

	useEffect(() => {
		const composedCss = ckeditorCss + resizableCkeditorStylesForDocumentDetail

		const style = document.createElement('style')
		style.appendChild(document.createTextNode(composedCss))

		document.head.appendChild(style)

		// Clean-up function
		return () => {
			document.head.removeChild(style)
		}
	})

	return (
		<Widget
			{...props}
			type={'Parágrafo Composto'}
			icon={<Icon $error={!valid} />}
			onValidate={setValid}
			formItems={
				<div>
					<CommonFields data={data} update={update} />
					<FormItem label="valor inicial">
						<div id="toolbar-container" />
						<div
							style={{
								overflowY: 'scroll',
								height: '200px',
							}}>
							<CKEditor
								editor={Editor}
								config={{
									toolbar: ['bold', 'italic', 'underline'],
								}}
								onBlur={(event, editor) => {
									update({ initialValue: editor.getData() })
								}}
								data={data.initialValue}
							/>
						</div>
					</FormItem>
					{hasContextAi && (
						<FormItem label="Prompt">
							<Input.TextArea
								onBlur={(e) => update({ prompt: e.target.value })}
								defaultValue={data.prompt}
								autoSize={{ minRows: 3, maxRows: 6 }}
								autoComplete="off"
							/>
						</FormItem>
					)}
				</div>
			}
		/>
	)
})

const Icon = styleIconValidation(AlignLeftOutlined)

ParagraphCkeditorWidget.propTypes = {
	data: object,
}
